import React from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import PageTitle from './PageTitle';

const PageNavigateTitle = ({ title, link, className }) => {
  const isMobileView = useSelector((state) => state.screen.isMobileView);
  const iconSize = isMobileView ? 20 : 28;
  return (
    <div className={twMerge(`w-fit flex items-center gap-2`, className)}>
      <Link to={link}>
        <IoArrowBack size={iconSize} className="text-contrast2 hover:text-contrast1 duration-300" />
      </Link>
      <PageTitle title={title} />
    </div>
  );
};

export default PageNavigateTitle;
